// extracted by mini-css-extract-plugin
export default {"rowCell":"rJD_E","studentCell":"l7T8N","studentName":"Nh388","studentEmail":"TI1Qa","results":"JS29g","resultsOpened":"uLBKr","resultsTriggerIcon":"w4jbl","resultsTable":"CVy0D"};